import { Component, type ReactNode } from "react";

interface AppErrorBoundaryProps {
  children: ReactNode;
}

interface AppErrorBoundaryState {
  failed: boolean;
}

export class AppErrorBoundary extends Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  public override state: AppErrorBoundaryState = { failed: false };

  public static getDerivedStateFromError(): AppErrorBoundaryState {
    return { failed: true };
  }

  public override render() {
    return this.state.failed ? <ApplicationFailureScreen /> : this.props.children;
  }
}

export function ApplicationFailureScreen() {
  return (
    <main className="centered-screen" role="alert">
      <p className="eyebrow">INTERFACE RECOVERY</p>
      <h1>Polyfuture could not render this view safely.</h1>
      <p>
        No portfolio, what-if, or decision was changed. Reload the application to recover the
        current server state.
      </p>
      <button
        className="button button-primary"
        type="button"
        onClick={() => window.location.reload()}
      >
        Reload Polyfuture
      </button>
    </main>
  );
}
